import React, { useState } from "react";
import { Col, Button, Card, CardBody } from "reactstrap";
import moment from "moment";
import { drawAasmState } from "../commons/Functions";

const PublicationsHit = ({ hit, is_public, canAdmin }) => {
  const [publication] = useState(hit._source);

  const handleClick = (e) => {
    e.preventDefault();
    window.location.href = `/publications/${publication.slug}`;
  };

  return (
    <Col xl="4" lg="4" md="6" sm="12" className="mb-3">
      <Card className="mb-3 publication-list-item job-card material-shadow item-card hover-scale-card h-100">
        <div 
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
          className="text-decoration-none"
        >
          <CardBody>
            <div className="d-flex justify-content-between flex-wrap">
              <div className="flex-grow-1 pe-md-3 p-0">
                <div className="mb-3 d-flex align-items-start gap-2">
                  <h2 className="fs-5 mb-1 fw-bold flex-grow-1" id="publication_title">
                    {publication.course.title}
                  </h2>

                </div>
                {canAdmin && <span>{drawAasmState(publication.aasm_state)}</span>}
                <ul className="fa-ul list-unstyled mb-0 ms-4 publication-detail-list" id="publication-detail-list">
                  <li>
                    <span className="fa-li">
                      <i className="far fa-calendar-alt" title="Fecha de Publicación"></i>
                    </span>
                    {moment(publication.created_at).format("DD/MM/YYYY")}
                  </li>
                  <li>
                    <span className="fa-li">
                      <i className="fas fa-business-time" title="Jornada, Horarios o Turnos"></i>
                    </span>
                    {publication.preferred_schedule &&
                      I18n.t(
                        "activerecord.enums.personal/laboral_requirement.preferred_schedules." +
                        publication.preferred_schedule
                      )}
                  </li>
                  {!publication.isConfidential && (
                    <li>
                      <span className="fa-li">
                        <i className="fas fa-map-marker-alt" title="Ubicación"></i>
                      </span>
                      {`${publication.address}. ${publication.commune.name}, ${publication.region.name}, ${publication.country.name}`}
                    </li>
                  )}
                </ul>
              </div>

              <div className="p-0 flex-lg-shrink flex-fill text-end d-flex flex-column flex-sm-row flex-md-row flex-lg-column align-items-center justify-content-between mt-3 mt-lg-0">
                <Button
                  size="sm"
                  color="primary"
                  className="my-3 align-self-center mb-lg-0"
                >
                  Ver Oferta
                </Button>
              </div>
            </div>
          </CardBody>
        </div>
      </Card>
    </Col>
  );
};

export default PublicationsHit;
